import background from './background';
import borderColor from './border-color';

export default {
  background,
  borderColor,
};
